/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WaveSummary } from './waveSummary';
import { TaskActionResultSummary } from './taskActionResultSummary';
import { ActionResultSummary } from './actionResultSummary';
import { TargetSummary } from './targetSummary';
import { AddableTargetsSummary } from './addableTargetsSummary';


export interface RolloutPlanSummary { 
    waves_summary?: Array<WaveSummary>;
    targets_summary?: Array<TargetSummary>;
    actions_summary?: Array<ActionResultSummary>;
    /** @deprecated */
    tasks_summary?: Array<TaskActionResultSummary>;
    addable_targets_summary?: AddableTargetsSummary;
}

